var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFemale(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 52,
    viewBox: "0 0 30 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4782 50.1507H6.18066V11.8042C6.18066 8.48611 7.93355 5.46877 10.6747 4.06837L18.6204 0.321902C20.9508 -0.868586 23.4782 1.42234 23.4782 4.24324L23.5358 50.0876C23.5356 50.1225 23.5099 50.1507 23.4782 50.1507Z",
    fill: "#DD0004"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5361 33.356C24.6939 33.3562 25.6327 34.3863 25.6328 35.6567V41.0503H20.3779V41.0327L20.3721 41.0503H4.07715V35.6577C4.0772 34.387 5.01594 33.3572 6.17383 33.3569L18.2754 33.356C18.2969 33.356 18.3192 33.3582 18.3418 33.3589C18.3218 33.3583 18.3014 33.356 18.2812 33.356H23.5361Z",
    fill: "#5B5555"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6729 39.3408C28.8008 39.341 29.7157 40.3444 29.7158 41.582V49.6494C29.7158 50.9476 28.7562 52 27.5732 52H2.14258C0.959461 51.9998 7.44693e-05 50.9468 0 49.6484V41.582C0 40.3444 0.914442 39.341 2.04199 39.3408H27.6729Z",
    fill: "#8E8E8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemale);
export default __webpack_public_path__ + "static/media/female.4eb334d35bd71ab73cd3aff2ca4ce317.svg";
export { ForwardRef as ReactComponent };